app.service('selectModal', function(modal) {
	var $select, $hidden, $label;
	let isOneInit = false;

	function setEvents(){
		if(!isOneInit){
			isOneInit = true;
			$('body').on('click','.js-select-modal', function() {
				$select = $(this);
				$label = $select.find("span.input-link");
				$hidden = $select.find(".hidden-select");

				modal.open( $select.data("modal"), {
					modifier: 'remodal-full-width'
				});
			}).on('click','.js-select-modal-radio', function() {
				var $option = $(this);
				var $label = $option.closest("label");
				var text = $option.data('text');
				if (!text) {
					text = $label.find('.text').length ? $label.find('.text').text() : $label.text();
				}
				selectOption($option.val(), text);
			});

			$(document).on('pageChange',function(){
				destroy();
			});
		}
	}

	function destroy(modalId){
		var modalList = [];

		if (modalId){
			if(typeof modalId === 'string'){
				modalList.push(modalId);
			}
			if(typeof modalId === 'object'){
				modalList = modalList.concat(modalId);
			}
		}else{
			$('.modal-select.remodal').each(function(){
				modalList.push($(this).data('remodal-id'));
			});
		}

		$(modalList).each(function(i,element){
			modal.destroy(element);
		});
	}

	function selectOption(selectedValue, selectedLabel){
		$label.text($.trim(selectedLabel));
		$hidden.val(selectedValue).change();
		if( $hidden.hasClass("error") ){
			$hidden.valid();
		}
		modal.close();
	}

	function init() {
		setEvents();
	}

	return {
		init,
		destroy
	};
});
